import { getType, Reducer } from 'typesafe-actions'

import { withLoadingReducer } from '../loading'

import { OrdersActions } from './actions'
import { OrdersState } from './types'

export const initialState: OrdersState = {
  data: [],
  page: 1,
  totalPages: 1,
  searchFilter: '',
  filters: {}
}

export const reducer: Reducer<OrdersState, OrdersActions> = (state = initialState, action) => {
  switch (action.type) {
    case getType(OrdersActions.loadOrders): {
      return {
        ...state,
        page: action.payload.page
      }
    }
    case getType(OrdersActions.setOrders): {
      return {
        ...state,
        data: action.payload.data,
        page: action.payload.page,
        totalPages: action.payload.totalPages
      }
    }
    case getType(OrdersActions.setFilters): {
      return {
        ...state,
        filters: action.payload
      }
    }
    case getType(OrdersActions.clearFilter): {
      const filters = { ...state.filters }
      delete filters[action.payload.filterKey]
      return {
        ...state,
        filters: filters
      }
    }
    case getType(OrdersActions.setSearchFilter): {
      return {
        ...state,
        searchFilter: action.payload
      }
    }
    default:
      return state
  }
}

export const ordersReducer = withLoadingReducer(reducer, 'orders', initialState)
